import WaitListContent from './WaitlistContent';

export function handleWaitlistClick(evt) {
  const el = document.querySelector('[data-waitlist-modal]');
  if (!el) return;

  const variantSelector = evt.target.closest('[data-waitlist-open="true"]');
  const container = variantSelector.closest('[data-section-type="product"]');
  // Prefer canonical Shopify product JSON when available; fallback to existing
  let productJsonScript =
    container.querySelector('[data-product-json-canonical]') || container.querySelector('[data-product-json]');
  if (!productJsonScript) {
    const parentProduct = container.parentElement?.closest('[data-section-type="product"]');
    if (parentProduct) {
      productJsonScript =
        parentProduct.querySelector('[data-product-json-canonical]') ||
        parentProduct.querySelector('[data-product-json]');
    }
  }

  const parseJsonSafe = (el) => {
    try {
      return el ? JSON.parse(el.textContent || el.innerHTML) : null;
    } catch (e) {
      return null;
    }
  };

  let productJson = parseJsonSafe(productJsonScript);

  // If canonical JSON missing, try to fetch it from the product URL inside QuickView
  if (!productJson) {
    const productLink = container.querySelector('.ProductHeading__title a[href*="/products/"]');
    const href = productLink ? productLink.getAttribute('href') : '';
    const handleFromUrl = href && href.includes('/products/') ? href.split('/products/')[1].split('?')[0] : '';
    if (handleFromUrl) {
      try {
        // Fire-and-forget synchronous usage; Waitlist modal will initialize after fetch resolves
        // Note: we block building the modal until we have JSON to ensure correct SKUs
        // eslint-disable-next-line no-new
        const req = new XMLHttpRequest();
        req.open('GET', `/products/${handleFromUrl}.js`, false);
        req.send(null);
        if (req.status >= 200 && req.status < 300 && req.responseText) {
          productJson = JSON.parse(req.responseText);
          // Attach into DOM for subsequent opens
          const canonicalScript = document.createElement('script');
          canonicalScript.type = 'application/json';
          canonicalScript.setAttribute('data-product-json-canonical', '');
          canonicalScript.textContent = JSON.stringify(productJson);
          container.appendChild(canonicalScript);
        }
      } catch (e) {
        // swallow; productJson stays null
      }
    }
  }

  if (!productJson) return;
  const variantColor = container
    .querySelector('.ProductOption__variant-custom--color.ProductOption__variant--selected')
    .getAttribute('data-value');

  let disclaimerMsg = `
    Yes! I want to be notified when this item is back in stock and would like to receive Windsor's newsletter with special offers and fashion trends delivered daily to my inbox. I understand I can unsubscribe at any time. *See our
    <a href='https://www.windsorstore.com/pages/contest-terms-conditions'>Terms and Conditions</a> and
    <a href='https://www.windsorstore.com/pages/privacy-policy'>Privacy Policy</a> for more details. Windsor, Inc., 9603 John St., Santa Fe Springs, CA 90670, (888) 494-6376*
  `;

  let waitlistPod = el.querySelector('.WaitlistModal__wrapper');
  if (!waitlistPod) {
    waitlistPod = document.createElement('div');
    waitlistPod.classList.add('WaitlistModal__wrapper');
  }

  const waitlistContentPod = document.createElement('div');
  const waitlistOverlay = document.createElement('div');
  waitlistContentPod.classList.add('WaitlistModal__container');
  waitlistOverlay.classList.add('WaitlistModal__overlay');

  const waitlistInstance = new WaitListContent(productJson, variantColor, disclaimerMsg);

  waitlistContentPod.appendChild(waitlistOverlay);
  waitlistContentPod.appendChild(waitlistInstance.getNode());
  waitlistPod.appendChild(waitlistContentPod);
  el.appendChild(waitlistPod);

  // Defer the event listener because it is not user-visible task
  setTimeout(() => {
    waitlistOverlay.addEventListener('click', () => {
      const waitlistWrapper = document.querySelector('.WaitlistModal__wrapper');
      if (waitlistWrapper) {
        waitlistWrapper.innerHTML = '';
      }
    });
  }, 0);
}

export default function () {
  const waitlistButtons = document.querySelectorAll('[data-waitlist-open="true"]');
  waitlistButtons.forEach((button) => {
    button.addEventListener('click', handleWaitlistClick);
  });
}
